import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { hasConsentChoice, grantConsent, denyConsent } from "@/lib/analytics";

export const CookieConsent = () => {
    const [show, setShow] = useState(false);

    useEffect(() => { setShow(!hasConsentChoice()); }, []);

    if (!show) return null;

    const accept = () => { grantConsent(); setShow(false); };
    const reject = () => { denyConsent(); setShow(false); };

    return (
        <div className="fixed bottom-0 inset-x-0 z-[2000] p-3 sm:p-4" data-testid="cookie-consent">
            <div className="max-w-4xl mx-auto bg-white border border-slate-200 shadow-lg rounded-lg p-4 flex flex-col sm:flex-row items-start sm:items-center gap-3">
                <Cookie className="w-6 h-6 text-mineral shrink-0" />
                <p className="text-xs sm:text-sm text-slate-600 flex-1 leading-relaxed">
                    Usamos cookies e tecnologias de medição (Google) para entender o uso e melhorar sua experiência.
                    Você pode aceitar ou rejeitar. Saiba mais na{" "}
                    <Link to="/privacidade" className="text-petroleum font-semibold hover:underline">Política de Privacidade</Link>{" "}
                    e nos{" "}
                    <Link to="/cookies" className="text-petroleum font-semibold hover:underline">Cookies</Link>.
                </p>
                <div className="flex gap-2 shrink-0 w-full sm:w-auto">
                    <button onClick={reject} data-testid="cookie-reject"
                        className="flex-1 sm:flex-none text-xs font-semibold px-4 py-2 rounded-sm border border-slate-300 text-slate-600 hover:bg-slate-50 transition-colors">
                        Rejeitar
                    </button>
                    <button onClick={accept} data-testid="cookie-accept"
                        className="flex-1 sm:flex-none text-xs font-semibold px-4 py-2 rounded-sm bg-mineral hover:bg-mineralHover text-white transition-colors">
                        Aceitar
                    </button>
                </div>
            </div>
        </div>
    );
};
